import { render, staticRenderFns } from "./platformTagBatch.vue?vue&type=template&id=f60bd584&scoped=true"
import script from "./platformTagBatch.vue?vue&type=script&lang=js"
export * from "./platformTagBatch.vue?vue&type=script&lang=js"
import style0 from "./platformTagBatch.vue?vue&type=style&index=0&id=f60bd584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60bd584",
  null
  
)

export default component.exports